{
  "version": 1,
  "asset_id": "77f6f213-c783-41e9-b3fe-b02f2a2d81c6",
  "project_id": "81864b6f-53ca-42c2-811b-21ffcbfd0515",
  "url": "/__l5e/assets-v1/77f6f213-c783-41e9-b3fe-b02f2a2d81c6/maison-genesis.webp",
  "r2_key": "a/v1/81864b6f-53ca-42c2-811b-21ffcbfd0515/77f6f213-c783-41e9-b3fe-b02f2a2d81c6/maison-genesis.webp",
  "original_filename": "maison-genesis.webp",
  "size": 104260,
  "content_type": "image/webp",
  "created_at": "2026-07-13T07:03:07Z"
}
